export default __webpack_public_path__ + "static/media/coding.9a51a37a.png";